<template>
<div v-loading.fullscreen.lock="fullscreenLoading">
    <!--コンテンツ-->
    <main id="renew3_mypage">
        <div class="mypage_back mypage_account">
            <div class="wrapper">
                <h2 class="m-h2">マイページ</h2>
                <p class="m-lead">マイページが新しくなりました。データバックアップ・復旧機能を利用したい場合は、<a href="/oldmypage" target="_blank"
                        class="text-link">旧マイページ</a>にアクセスしてください。</p>

                <div class="my-contents sp">

                    <mypagemenu-item viewFlag="my" ></mypagemenu-item>

                    <!--contents-->
                    <div class="my-contents_container">
                        <h2 class="m-h2">アカウント情報</h2>
                        <p class="m-lead">こんにちは<span>古舘葵</span>さん、<br>
                            <span>一般会員</span>としてログイン中です。
                        </p>

                        <ul class="list">
                            <li class="item">
                                <div class="list_wrap">
                                    <div class="item01">
                                        <p class="item01-01">名前</p>
                                        <p class="item01-02">{{username}}</p>
                                    </div>
                                </div>
                            </li>
                            <li class="item">
                                <div class="list_wrap">
                                    <div class="flex item01">
                                        <p class="item01-01">メールアドレス</p>
                                        <a href="" class="item02-01">メールアドレスの変更</a>
                                    </div>

                                    <div class="item02">
                                        <p class="item01-02">{{useremail}}</p>
                                    </div>
                                </div>
                            </li>
                            <li class="item">
                                <div class="list_wrap">
                                    <div class="flex item01">
                                        <p class="item01-01">会員タイプ</p>
                                        <a href="" class="item02-01">ヤギプラ会員特典を見る</a>
                                    </div>

                                    <div class="item02">
                                        <p class="item01-02">ヤギプライム会員</p>
                                    </div>
                                </div>
                            </li>
                            <li class="item">
                                <div class="list_wrap">
                                    <div class="item01">
                                        <p class="item01-01">決済方法※ヤギプラ会員のみ</p>
                                        <p class="item01-02">クレジットカード</p>
                                        <p class="item01-03">次回決済日：2023.12.13</p>
                                    </div>
                                </div>
                            </li>
                            <li class="item">
                                <div class="list_wrap">
                                    <div class="flex item01">
                                        <p class="item01-01">その他の設定</p>
                                        <a href="/mypage/accountother" class="item02-01">設定の変更</a>
                                    </div>
                                </div>
                            </li>
                        </ul>

                    </div>

                    <mypagemenu-item viewFlag="service" ></mypagemenu-item>

                </div>

                <div class="my-contents pc flex">
                    <div class="menu-column">

                        
                      <mypagemenu-item viewFlag="my" ></mypagemenu-item>

                      
                      <mypagemenu-item viewFlag="service" ></mypagemenu-item>
                    </div>

                    <div class="right-contents">
                        <!--contents-->
                        <div class="my-contents_container">
                            <h2 class="m-h2">アカウント情報</h2>
                            <p class="m-lead">こんにちは<span>古舘葵</span>さん、<br>
                                <span>一般会員</span>としてログイン中です。
                            </p>

                            <ul class="list">
                                <li class="item">
                                    <div class="list_wrap">
                                        <div class="item01">
                                            <p class="item01-01">名前</p>
                                            <p class="item01-02">{{username}}</p>
                                        </div>
                                    </div>
                                </li>
                                <li class="item">
                                    <div class="flex list_wrap">
                                        <div class="item01">
                                            <p class="item01-01">メールアドレス</p>
                                            <p class="item01-02">{{useremail}}</p>
                                        </div>

                                        <div class="item02">
                                            <a href="" class="item02-01">メールアドレスの変更</a>
                                        </div>
                                    </div>
                                </li>
                                <li class="item">
                                    <div class="flex list_wrap">
                                        <div class="item01">
                                            <p class="item01-01">会員タイプ</p>
                                            <p class="item01-02">ヤギプライム会員</p>
                                        </div>

                                        <div class="item02">
                                            <a href="" class="item02-01">ヤギプラ会員特典を見る</a>
                                        </div>
                                    </div>
                                </li>
                                <li class="item">
                                    <div class="flex list_wrap">
                                        <div class="item01">
                                            <p class="item01-01">決済方法※ヤギプラ会員のみ</p>
                                            <p class="item01-02">クレジットカード</p>
                                            <p class="item01-03">次回決済日：2023.12.13</p>
                                        </div>
                                    </div>
                                </li>
                                <li class="item">
                                    <div class="flex list_wrap">
                                        <div class="item01">
                                            <p class="item01-01">その他の設定</p>
                                        </div>

                                        <div class="item02">
                                            <a href="/mypage/accountother" class="item02-01">設定の変更</a>
                                        </div>
                                    </div>
                                </li>
                            </ul>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </main>
</div>
</template>

<style lang="css" src="@/assets/css/renew3_mypage.css"></style>
<style scoped>
@import "/static/css/slick-theme.css";
@import "/static/css/slick.css";
/* @import url("//unpkg.com/element-ui@2.15.13/lib/theme-chalk/index.css"); */
</style>


<script>
import {
  TabPane,
  Tabs,
  MessageBox
} from 'element-ui'
import LoginForms from '@/components/RenewLoginForms'
import Slick from 'vue-slick'
import firebase from 'firebase/app'
import MypageCommonMenu from '@/components/formats/CommonParts/MypageCommonMenu'

const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const DOC_PAPER_HEIGHT_PX = 794
export default {
  components: {
    'el-tabs': Tabs,
    'el-tab-pane': TabPane,
    'login-forms': LoginForms,
    'mypagemenu-item': MypageCommonMenu,
    Slick
  },
  data: function () {
    return {
		  fullscreenLoading: true,
      recentEdit: {
        FormatId: ''
      },
      introData: {},
      backupList: {
        auto: [],
        user: []
      },
      dialogVisible:false,
      username:'',
      useremail:'',
      selectedYagiOfferData:{},
      selectedQuickEmailData:{},
      mypagedata: [],
      quickemailList: [],
      qmail_rirekisho_html: '',
      qmail_shokumukeirekisho_html: '',
      joblistKeyword: '',
      joblistArea: '',
      backupListLoaded: {
        auto: false,
        user: false
      },
      slickOptions:{
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 2400,
        speed: 400
      },
      saved: false,
      recomm_code:'',
      saveLabel: '',
      backupDataToConfirm: null,
      previewScale: 1,
      previewQEmailScale: 1,
      backupDataViewerCssRirekisho: {},
      backupDataViewerCssShokurekisho: {},
      qmailViewerCssRirekisho: {},
      qmailViewerCssShokurekisho: {},
      deleteBackupPopoverVisible: false,
      previewLoading: false,
      rirekisho_height: 110,
      keirekisho_height: 110,
      previewQEmailLoading: false,
      job_list:[],
      activeTabName: 'user',
      activePreviewTab: 'format_rirekisho',
      activeQEmailPreviewTab: 'format_rirekisho',
      search_id:''
    }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    getFormatName:function(format_id) {
      for(let p of this.$site.formatsIndex){
        if (p.id == format_id) {
          return p.title
        }
      }
      for(let p of this.$site.keirekishoFormatsIndex){
        if (p.id == format_id) {
          return p.title
        }
      }
      return '-'
    },
    clickJob: async function (_item) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', 'mypage')
      formData.append('keyword', this.joblistKeyword)
      formData.append('area', this.joblistArea)


      formData.append('jt', _item.jt)
      formData.append('st', _item.st)
      formData.append('title', _item.title)
      formData.append('company', _item.company)
      formData.append('snippet', _item.snippet)
      formData.append('clicklink', _item.url)


      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'r')
      formData.append('app_flag', this.$site.appFlag)

      const app = this
      this.$axios.post(this.$varuna.endPoints.clickKakakuJob, formData, {timeout: 60000})
    },
    clickCarat: async function (_item) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      this.search_id = ''
      this.$eventHub.$emit('open-carat-dialog', 'mypage', null, this.joblistKeyword, this.joblistArea, null, 2, _item, this.search_id)

      
      // const formData = new FormData()
      // formData.append('uuid', this.$firebase.user.uid)
      // formData.append('format_id', 'mypage')
      // formData.append('occupation', '正社員')

      // formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      // formData.append('version', '2')
      // formData.append('site_flag', 'r')
      // formData.append('app_flag', this.$site.appFlag)

      // const app = this
      // this.$axios.post(this.$varuna.endPoints.applicationCarat, formData, {timeout: 60000})
    },
    applicantCarat: async function (jobid) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = new FormData()
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('job_id', jobid)
      formData.append('format_id', 'mypage')
      this.search_id = ''
      formData.append('search_id', this.search_id)
      formData.append('yaginame', this.username)
      formData.append('detail_flag', '')
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'mypage')
      formData.append('permission_type', 1)
      formData.append('version', '2')
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      if (this.age >= 50 && this.age <= 59) {
        formData.append('keyword', '50代')
      }  else {
        formData.append('keyword', this.joblistKeyword)
      }
      formData.append('area', this.joblistArea)

      formData.append('occupation', '正社員')
      
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.applicationCarat, formData, {timeout: 60000})
        .then(function (response) {
          // app.nowStep = 3
          // app.isSended = false
          app.$message({
            message: '応募完了しました。',
            type: 'info'
          })
          for (var _key in app.job_list) {
            if (app.job_list[_key].id==jobid) {
              app.job_list[_key].is_applicated = true
            }
          }
          // app.$eventHub.$emit('open-carat-dialog', 'mypage', null, app.joblistKeyword, app.joblistArea, null, 3, jobid, app.search_id)
        })
        .catch(function (error) {
          app.$message({
            message: '応募失敗しました。',
            type: 'error'
          })
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    applicantCarat4Confirm: async function (jobid) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      // if(!confirm('本当に応募しますか？')) {
      //   return
      // }
      this.fullscreenLoading = true
      const formData = new FormData()
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('job_id', jobid)
      formData.append('format_id', 'mypage')
      this.search_id = ''
      formData.append('search_id', this.search_id)
      formData.append('yaginame', this.username)
      formData.append('detail_flag', '')
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'mypage')
      formData.append('permission_type', 1)
      formData.append('version', '2')
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      if (this.age >= 50 && this.age <= 59) {
        formData.append('keyword', '50代')
      }  else {
        formData.append('keyword', this.joblistKeyword)
      }
      formData.append('area', this.joblistArea)

      formData.append('occupation', '正社員')
      
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.applicationCarat, formData, {timeout: 60000})
        .then(function (response) {
          // app.nowStep = 3
          // app.isSended = false
          app.$message({
            message: '応募完了しました。',
            type: 'info'
          })
          for (var _key in app.job_list) {
            if (app.job_list[_key].id==jobid) {
              app.job_list[_key].is_applicated = true
            }
          }
          // app.$eventHub.$emit('open-carat-dialog', 'mypage', null, app.joblistKeyword, app.joblistArea, null, 3, jobid, app.search_id)
        })
        .catch(function (error) {
          app.$message({
            message: '応募失敗しました。',
            type: 'error'
          })
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendEmailVerification: async function() {
      const app = this
      await this.$firebase.user.sendEmailVerification().then(() => {
        app.$message({
          message: '送信しました。メール内のリンクをクリックしてください',
          type: 'success'
        })
        
      }).catch((error) => {
        app.$message({
          message: '送信失敗しました。',
          type: 'error'
        })
      })
    }
  },
  created: function () {
    
    const app = this
    console.error("created:"+this.$route.query.custom_token)
    if (this.$route.query.custom_token) {

      firebase.auth().signInWithCustomToken(this.$route.query.custom_token)
      .then((userCredential) => {
        let user = userCredential.user
        if (user) {    
          console.log('mypage logined')
          const formData = new FormData()
          formData.append('uuid', user.uid)
          formData.append('version', '2')
          formData.append('reqflg', '2')
          formData.append('email', user.email)
          formData.append('site_flag', 'r')
          formData.append('device_flag', app.$deviceLib.isMobileDevice ? 'SP': 'PC')
          formData.append('email_verified', user.emailVerified?'1':'0')

          app.$axios
            .post(app.$varuna.endPoints.getMypageHistory, formData, {timeout: 60000})
            .then(function (response) {
              app.mypagedata = response.data
              if (app.$firebase.user.displayName) {
                app.username = app.$firebase.user.displayName
                app.useremail = app.$firebase.user.email
              } else if (app.mypagedata.memberdata.lastname) {
                app.username = app.mypagedata.memberdata.lastname + " " + app.mypagedata.memberdata.firstname
                app.useremail = app.$firebase.user.email
              } else {
                app.username = app.$firebase.user.email
              }
              console.error(app.mypagedata.memberdata.offers)
              app.joblistKeyword = app.mypagedata.memberdata.keyword
              app.joblistArea = app.mypagedata.memberdata.area
              app.job_list = app.mypagedata.memberdata.offers.offers
              app.search_id = app.mypagedata.memberdata.offers.search_id

            })
            .catch(function (error) {
              if (app.$firebase.user.displayName) {
                app.username = app.$firebase.user.displayName
                app.useremail = app.$firebase.user.email
              } else {
                app.username = app.$firebase.user.email
              }
            }).finally(function () {
            })

          app.fullscreenLoading = false

        }
        

      })
      .catch((error) => {
        var errorCode = error.code
        var errorMessage = error.message
        console.error(errorCode+errorMessage)

      })
    } else {
      // console.log(this.$route.query.mynavi)
      firebase.auth().onAuthStateChanged((user) => {
        console.log('mypage onAuthStateChanged')
        if (user) {    
          console.log('mypage logined')
          const formData = new FormData()
          formData.append('uuid', user.uid)
          formData.append('version', '2')
          formData.append('reqflg', '2')
          formData.append('email', user.email)
          formData.append('site_flag', 'r')
          formData.append('device_flag', app.$deviceLib.isMobileDevice ? 'SP': 'PC')
          formData.append('email_verified', user.emailVerified?'1':'0')
          var affiliate_id  = this.$cookies.get('_YAGISH_AFFILIATE_ID')
          if (affiliate_id) formData.append('affiliate_id', affiliate_id)

          app.$axios
            .post(app.$varuna.endPoints.getMypageHistory, formData, {timeout: 60000})
            .then(function (response) {
              app.mypagedata = response.data
              if (app.$firebase.user.displayName) {
                app.username = app.$firebase.user.displayName
                app.useremail = app.$firebase.user.email
              } else if (app.mypagedata.memberdata.lastname) {
                app.username = app.mypagedata.memberdata.lastname + " " + app.mypagedata.memberdata.firstname
                app.useremail = app.$firebase.user.email
              } else {
                app.username = app.$firebase.user.email
              }
              console.error(app.mypagedata.memberdata.offers)
              app.joblistKeyword = app.mypagedata.memberdata.keyword
              app.joblistArea = app.mypagedata.memberdata.area
              app.job_list = app.mypagedata.memberdata.offers.offers
              app.search_id = app.mypagedata.memberdata.offers.search_id

            })
            .catch(function (error) {
              if (app.$firebase.user.displayName) {
                app.username = app.$firebase.user.displayName
                app.useremail = app.$firebase.user.email
              } else {
                app.username = app.$firebase.user.email
              }
            }).finally(function () {
            })

          app.fullscreenLoading = false

        } else {
          console.log('mypage login')
          app.$router.push('/login')
        }
      })
    }

        
  },
  beforeMount: function () {
    console.error("beforeMount:"+this.$route.query.custom_token)
  },
  destroyed: function () {
  }
}
</script>
